export enum UserRoles {
	USER = 'User',
	POWER_USER = 'PowerUser',
	API_USER = 'API_USER',
	BANNED = 'Banned',
	SUPER_ADMIN = 'SuperAdmin',
}